import type { AllRouteEndpoints } from "../routeTypes";
export const engagementProductRecommendationsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/product_recommendations(/:recommender_id)",
];
